import { BaggageType } from '@websky/graphql';
import { SetServicesAction } from './actions';
import { UpgradeModalState } from './types';
import { SelectedUpgrade } from '../types';

export function getMinCountServiceKey(service: SelectedUpgrade): string {
	return `${service.serviceId}/${service.passengerId}`;
}

export function getServiceKey(service: SelectedUpgrade): string {
	const segmentIds = service.segmentIds.join('-');

	return [service.serviceId, service.passengerId, segmentIds].join('/');
}

export function getSelectedServicesByType(state: UpgradeModalState, action: SetServicesAction): SelectedUpgrade[] {
	const { items, type } = action.payload;

	const selectedServicesMap = new Map<string, SelectedUpgrade>();

	state.selectedServices.forEach(service => {
		const key = getServiceKey(service);

		selectedServicesMap.set(key, service);
	});

	if (type === 'radio') {
		// reset the selected services on the segment for the passenger, as only one service can be selected
		selectedServicesMap.forEach((selectedService, key) => {
			const baggageType = state.services.find(service => service.id === selectedService.serviceId)?.type;

			if (baggageType === BaggageType.BaggageExcess) {
				items.forEach(newService => {
					if (
						newService.passengerId === selectedService.passengerId &&
						newService.segmentIds.join('/') === selectedService.segmentIds.join('/')
					) {
						selectedServicesMap.set(key, { ...selectedService, count: 0 });
					}
				});
			}
		});
	}

	items.forEach(newService => {
		const key = getServiceKey(newService);

		selectedServicesMap.set(key, newService);
	});

	return [...selectedServicesMap.values()];
}
